// extracted by mini-css-extract-plugin
export default {"content":"discountCodeListContainer_content__feXfZ"};